import React, { useMemo } from 'react'
import { Slide, makeStyles } from '@material-ui/core'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import OpalCard from '../../../../components/opal/OpalCard'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import FlexRow from '../../../../components/molecules/FlexRow'
import { useUserReadingList } from '../../../../api/denaliAssistant'

const useStyles = makeStyles(() => ({
  card: {
    backgroundColor: 'var(--dai-color-notify) !important',
    borderColor: 'var(--dai-color-notify-border)',
    color: 'var(--dai-contrast-notify)',
    transition: 'background-color var(--transition-duration-medium) var(--transition-easing-normal), border-color var(--transition-duration-medium) var(--transition-easing-normal)',
    '&:hover': {
      backgroundColor: 'color-mix(in srgb, var(--color-ai-400) 80%, transparent) !important',
      borderColor: 'var(--color-ai-600)'
    }
  },
  count: {
    backgroundColor: 'var(--dai-color-input)',
    color: 'var(--dai-contrast-input)'
  }
}))

function ReadingListNotification () {
  const classes = useStyles()
  const { data, isLoading } = useUserReadingList()
  const count = useMemo(() => {
    return data?.scheduledPrompts?.filter(x => !x.readDateUtc)?.length || 0
  }, [data])

  if (isLoading) return null
  if (!count) return null

  return (
    <FadeIn duration={1} className='absolute' style={{ top: 10, right: 10 }}>
      <Slide in direction='left' timeout={500}>
        <div>
          <Link className='rich' to='/denali-ai/reading-list'>
            <OpalCard className={clsx(classes.card, 'font-serif shadow-sm select-none')}>
              <FlexRow className='gap-sm'>
                <div className='pr-1 pl-5 py-2'><em>Reading List</em></div>
                <div className={clsx(classes.count, 'mr-5 px-2 radius-round')}>{count}</div>
              </FlexRow>
            </OpalCard>
          </Link>
        </div>
      </Slide>
    </FadeIn>
  )
}

export default ReadingListNotification
